// ───────────────────────────────────────────────────────────────
// FullStop — configuración central del producto y la marca.
// Cambia BRAND aquí y se actualiza en toda la web (nav, hero, footer…).
// El precio real de venta se define TAMBIÉN en el backend (fuente de verdad).
// ───────────────────────────────────────────────────────────────

export const BRAND = "FullStop";
export const TAGLINE = "El cargador que se apaga solo al llegar al 100%.";

export const PRODUCT = {
  name: "Cargador Inteligente FullStop",
  // Precio de venta (€). El backend valida este mismo importe en el pago.
  priceEur: 36.99,
  compareAtEur: 54.99,
  currency: "EUR",
  // Foto principal (hero) y galería — fotos reales del producto.
  hero: "/images/charger/charger-2.jpg",
  gallery: [
    "/images/charger/charger-2.jpg",
    "/images/charger/charger-1.jpg",
  ],
};

// Beneficios (rejilla de características). metric = número grande.
export const FEATURES = [
  {
    metric: "100%",
    metricLabel: "y corta solo",
    title: "Desconexión automática",
    body: "Cuando tu dispositivo termina de cargar y deja de consumir, corta el paso de corriente por sí solo. Adiós a dejarlo enchufado toda la noche.",
  },
  {
    metric: "140W",
    metricLabel: "carga rápida",
    title: "Potencia de sobra",
    body: "Compatible con carga rápida USB-C de hasta 140W: sirve igual para el móvil que para la tablet o el portátil.",
  },
  {
    metric: "USB-C",
    metricLabel: "universal",
    title: "Compatible con todo",
    body: "iPhone 15/16, Android, iPad y portátiles con USB-C. Se coloca entre tu cargador y el cable, sin instalar nada.",
  },
  {
    metric: "+vida",
    metricLabel: "para tu batería",
    title: "Cuida la batería",
    body: "Cortar la corriente al terminar la carga ayuda a que el dispositivo no pase horas enchufado de más. Con protección frente a sobrecalentamiento.",
  },
];

// Cómo funciona (3 pasos).
export const HOW_IT_WORKS = [
  {
    step: "01",
    title: "Conéctalo",
    body: "Enchúfalo entre tu cargador de pared y el cable USB-C. No necesita apps ni configuración.",
  },
  {
    step: "02",
    title: "Carga normal",
    body: "Carga tu móvil, tablet o portátil como lo haces siempre. La velocidad de carga no cambia.",
  },
  {
    step: "03",
    title: "Se apaga solo",
    body: "Cuando tu dispositivo termina de cargar y deja de consumir corriente, FullStop corta el paso de energía automáticamente.",
  },
];

// Especificaciones técnicas.
export const SPECS = [
  { label: "Potencia", value: "Hasta 140W" },
  { label: "Conector", value: "USB-C (PD)" },
  { label: "Corte automático", value: "Al completar la carga" },
  { label: "Compatibilidad", value: "iPhone · Android · iPad · portátil" },
  { label: "Protecciones", value: "Sobrecarga · calor" },
  { label: "Indicador", value: "LED de estado" },
  { label: "Color", value: "Blanco / Gris" },
  { label: "Garantía", value: "2 años" },
];

// Preguntas frecuentes.
export const FAQS = [
  {
    q: "¿Funciona con mi móvil?",
    a: "Sí, con cualquier dispositivo que cargue por USB-C: iPhone 15/16, móviles Android, iPad y portátiles con USB-C.",
  },
  {
    q: "¿De verdad se apaga solo al terminar?",
    a: "Sí: cuando tu dispositivo termina de cargar y deja de pedir corriente, FullStop corta el paso de energía automáticamente, para que no se quede enchufado de más.",
  },
  {
    q: "¿La carga es más lenta?",
    a: "No. Deja pasar toda la potencia (hasta 140W) mientras carga; solo actúa cuando llega al 100%.",
  },
  {
    q: "¿Cómo se paga y cuándo llega?",
    a: "Pago seguro con tarjeta vía Stripe (no guardamos los datos de tu tarjeta). Preparamos tu pedido en 24-48 h laborables.",
  },
];

// Contacto (llega a tu correo personal a través del backend).
export const SUPPORT_EMAIL = "edusanchez98.98@gmail.com";
